import { render, staticRenderFns } from "./PatientLabelsRep.vue?vue&type=template&id=5b396a6e&"
import script from "./PatientLabelsRep.vue?vue&type=script&lang=js&"
export * from "./PatientLabelsRep.vue?vue&type=script&lang=js&"
import style0 from "./PatientLabelsRep.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports